<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center align-items-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 col-md-6 mt-4" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"navprofile\",\"params\":{}}","target":"_self"},...{}}' :style='"\n"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 25px;\n transition: transform 0.3s ease, box-shadow 0.3s ease;"' class="col-12 bg-secondary p-4 text-center shadow  border card-profile-wrapper" >
                <template #default>   <m-icon v-bind='{...{"icon":"person-check"},...{}}' :style='"font-size: 85px;\nborder-radius: 15px;"' class="h1 text-warning bg-white p-2 px-5 shadow" ></m-icon><m-h5 v-bind='{...{},...{}}' :style='"border-radius: 15px;"' class="mt-5 bg-primary  p-3 text-white shadow " >
                <template #default>پروفایل فروشنده   </template>
                </m-h5></template>
                </m-div></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6 col-md-6 mt-4" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"userprofile\",\"params\":{}}","target":"_self"},...{}}' :style='"\n"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 25px;\n transition: transform 0.3s ease, box-shadow 0.3s ease;"' class="col-12 bg-secondary p-4 text-center shadow  border card-profile-wrapper" >
                <template #default>   <m-icon v-bind='{...{"icon":"people"},...{}}' :style='"font-size: 85px;\nborder-radius: 15px;"' class="h1 text-danger bg-white p-2 px-5 shadow" ></m-icon><m-h5 v-bind='{...{},...{}}' :style='"border-radius: 15px;"' class="mt-5 bg-primary  p-3 text-white shadow " >
                <template #default>پروفایل خریدار   </template>
                </m-h5></template>
                </m-div></template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mA,mIcon,mH5 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
